/**
 * 认证工具 - 本地 token 管理
 */

/**
 * 获取当前登录用户的 access token
 */
export async function getAccessToken() {
    return localStorage.getItem('utimes_token') || null
}

/**
 * 获取当前用户
 */
export async function getCurrentUser() {
    const token = localStorage.getItem('utimes_token')
    return token ? { id: 'local' } : null
}

/**
 * 登出
 */
export async function signOut() {
    localStorage.removeItem('utimes_token')
}
